<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :params="params"
    :fields="fields"
    :searchDisable="false"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>

import { mapState, mapMutations } from "vuex";

export default {
  name: "groups",
  created() {
    this.params['categories_id'] = this.id;
  },
    props: ["id"],
  methods: {
    filterSet(val) {
      this.params.id = val;
      this.params.updatedAt = Date.now();
    },
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      /**START ADD ITEM */
      val: [],
      params: {},
      modalCreate: "product",
      fields: [
        {
          key: "product",
          label: "Группа товаров",
          type: "object",
          subFields: [
            {
              label: "Бренд",
              key: "brand",
              type: "select",
              selectKey: "title",
              modal: "brands",
            },
            {
              label: "Класс товара",
              key: "name",
              type: "select",
              selectKey: "title",
              modal: "name",
            },
    
          ],
        },
        {
          key: "name",
          label: "Название модели (уникальность)",
          type: "field",
          textType: "text",
        },
        {
          key: "title",
          label: "Доп. название",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
        {
          label: "Цвет",
          key: "color",
          type: "select",
          selectKey: "title",
          modal: "color",
        },

        {
          key: "sku",
          label: "Баркод",
          type: "field",
          textType: "text",
        },
        {
          key: "price",
          label: "Цена",
          type: "field",
          textType: "number",
        },
        {
          key: "quantity",
          label: "Количество",
          type: "field",
          textType: "number",
        },
      ],
      /** APIs */
      removeLink: "products/delete",
      cardLink: "products",
      itemLink: "products/list",
      setLink: "products/add",
      /** COLUMNS MODEL */
      columns: [
           {
          key: "image",
          title: "",
          checkbox: false,
          image: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "sku",
          title: "Баркод",
          control: false,
          full: true,
          align: "left",
          checkbox: false,
          sortBy:'sku'
        },
        {
          key: "display_name",
          title: "Название",
          full: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_active",
          title: "Активный",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price",
          title: "Цена",
          checkbox: false,
          control: false,
          sortBy:'price'
        },
        {
          key: "price_main",
          title: "Главная цена",
          checkbox: false,
          control: false,
          sortBy:'price_main'
        },
        {
          key: "quantity",
          title: "Кол-во (шт.)",
          checkbox: false,
          control: false,
          sortBy:'quantity'
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
          control: false,
          sortBy:'created_at'
        },
        {
          key: "updated_at",
          title: "Обновлен",
          dateTimeFormat: true,
          control: false,
          sortBy:'updated_at'
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
